( function () {
	function scheduleRefresh() {
		const { ScrollTrigger } = window;

		if ( ! ScrollTrigger ) {
			return;
		}

		window.requestAnimationFrame( function () {
			window.requestAnimationFrame( function () {
				ScrollTrigger.refresh();
				ScrollTrigger.update();
			} );
		} );
	}

	function initBlock( block ) {
		const { gsap, ScrollTrigger } = window;

		if ( ! gsap || ! ScrollTrigger ) {
			return;
		}

		const cards = gsap.utils.toArray( '.stacking-cards .card', block );

		if ( cards.length < 2 ) {
			return;
		}

		gsap.registerPlugin( ScrollTrigger );

		const context = gsap.context( function () {
			const media = gsap.matchMedia();

			media.add( '(min-width: 1221px)', function () {
				const benefits = block.querySelector( '.benefits' );

				if ( ! benefits ) {
					return undefined;
				}

				gsap.set( cards, {
					yPercent: 260,
					opacity: 1,
					willChange: 'transform',
				} );

				gsap.set( cards[ 0 ], {
					yPercent: 0,
				} );

				const timeline = gsap.timeline( {
					scrollTrigger: {
						trigger: benefits,
						start: 'top top+=280',
						end: '+=' + ( cards.length - 1 ) * 280,
						scrub: 0.6,
						pin: benefits,
						anticipatePin: 1,
						invalidateOnRefresh: true,
					},
				} );

				cards.forEach( function ( card, index ) {
					if ( 0 === index ) {
						return;
					}

					timeline.to(
						card,
						{
							yPercent: 0,
							duration: 1,
							ease: 'power2.out',
						},
						index - 1
					);
				} );

				return function () {
					timeline.scrollTrigger?.kill();
					timeline.kill();
				};
			} );

			return function () {
				media.revert();
			};
		}, block );

		block.__whyChooseUsContext = context;
		scheduleRefresh();
	}

	function init() {
		document
			.querySelectorAll( '.wp-block-sweettyspace-why-choose-us' )
			.forEach( function ( block ) {
				if ( block.__whyChooseUsContext ) {
					return;
				}

				initBlock( block );
			} );

		scheduleRefresh();
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init, { once: true } );
	} else {
		init();
	}

	window.addEventListener( 'load', scheduleRefresh );
	window.addEventListener( 'pageshow', scheduleRefresh );

	if ( document.fonts?.ready ) {
		document.fonts.ready.then( scheduleRefresh ).catch( function () {} );
	}
} )();
